import { StyleSheet } from 'react-native';

const s = StyleSheet.create({
  overlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
  },
  dialog: {
    backgroundColor: '#1e2d3d',
    borderRadius: 10,
    maxHeight: '85%',
    borderWidth: 1,
    borderColor: '#3d5a73',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#3d5a73',
  },
  headerTitle: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 16,
    color: '#ffffff',
  },
  closeIcon: {
    padding: 4,
  },
  body: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    flex: 1,
  },
  footer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: '#3d5a73',
    gap: 10,
  },

  // Loading
  loadingContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 40,
  },
  loadingText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#E0E7EF',
    marginTop: 12,
  },

  // Error
  errorContainer: {
    alignItems: 'center',
    paddingVertical: 24,
  },
  errorText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#e74c3c',
    textAlign: 'center',
    marginTop: 10,
    marginBottom: 16,
    paddingHorizontal: 12,
  },
  retryButton: {
    backgroundColor: '#336599',
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  retryButtonText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#ffffff',
  },

  // Group rows
  scrollArea: {
    maxHeight: 400,
  },
  groupRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#253c57',
    borderRadius: 6,
    padding: 12,
    marginBottom: 8,
  },
  groupIcon: {
    marginRight: 10,
    width: 22,
    textAlign: 'center',
  },
  groupLabel: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 13,
    color: '#E0E7EF',
    flex: 1,
  },
  groupChevron: {
    marginLeft: 8,
  },

  // Expanded order list
  orderList: {
    backgroundColor: '#1a2a3a',
    borderRadius: 6,
    paddingVertical: 4,
    paddingHorizontal: 12,
    marginBottom: 8,
    marginTop: -4,
  },
  orderRow: {
    paddingVertical: 5,
    borderBottomWidth: 1,
    borderBottomColor: '#253c57',
  },
  orderText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 12,
    color: '#9aafc0',
  },

  // Footer buttons
  cancelButton: {
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
    borderWidth: 1,
    borderColor: '#5c778f',
  },
  cancelButtonText: {
    fontFamily: 'Poppins_500Medium',
    fontSize: 14,
    color: '#E0E7EF',
  },
  queueButton: {
    backgroundColor: '#1CBB77',
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  queueButtonDisabled: {
    backgroundColor: '#3d5a73',
    borderRadius: 6,
    paddingVertical: 10,
    paddingHorizontal: 20,
  },
  queueButtonText: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 14,
    color: '#ffffff',
  },
  queueButtonTextDisabled: {
    fontFamily: 'Poppins_600SemiBold',
    fontSize: 14,
    color: '#7a94a8',
  },
});

export default s;
